import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import dayjs from "dayjs";
import Helmet from "react-helmet";

import Publishing from "./Publishing";
import ReadBimClass from "./ReadBimClass.graphql";
import { StyledDetailHeader } from "../../../components/styles";

export default function BimClassTitle(props) {
    const { id, revisionID } = props;

    const readBimClass = useQuery(
        gql(ReadBimClass),
        {
            variables: {
                revisionID,
            },
        },
    );

    if (readBimClass.loading || readBimClass.error || !readBimClass.data?.bimClassRevision) return null;

    const isDeprecated = readBimClass.data.bimClassRevision.metadata.deprecated;
    const isPublic = readBimClass.data.bimClassRevision.metadata.tags.includes("public");
    const nameText = readBimClass.data.bimClassRevision.data.name[0]?.text ?? "Untitled BimClass";

    return (
        <StyledDetailHeader>
            <Helmet>
                <title>BC - { nameText } - BimClasses - taxonomy</title>
            </Helmet>
            <div className="title-row">
                <h1 title={ nameText }>{ nameText }</h1>
                <div className="status-badges">
                    { isDeprecated && <span className="badge deprecated">Deprecated</span> }
                    { isPublic ? (
                        <span className="badge public">Public</span>
                    ) : (
                        <span className="badge draft">Draft</span>
                    ) }
                    <Publishing
                        id={ id }
                        public={ isPublic }
                        revisionID={ revisionID }
                    />
                </div>
            </div>
            <div className="meta-row">
                <time>Created: { dayjs(readBimClass.data.bimClassRevision.metadata.createdAt).format("YYYY-MM-DD HH:mm:ss") }</time>
            </div>
        </StyledDetailHeader>
    );
}
